import React from 'react';

interface LoadingOverlayProps {
  message?: string;
  progress?: number;
  className?: string;
}

export function LoadingOverlay({ message = 'Loading...', progress, className = '' }: LoadingOverlayProps) {
  return (
    <div className={`loading-overlay ${className}`}>
      <div className="loading-spinner" style={{ width: 40, height: 40 }} />
      {message && <p className="loading-text">{message}</p>}
      {progress !== undefined && (
        <div className="progress-bar" style={{ width: 200 }}>
          <div className="progress-fill" style={{ width: `${progress}%` }} />
        </div>
      )}
    </div>
  );
}

